const baseEndpoint = 'https://api.mapbox.com/geocoding/v5/mapbox.places';

export const mapConfigs = {
    accessToken: 'pk.eyJ1IjoiY3dvb2RzaWRlIiwiYSI6ImNsMXV4NHAwaTJwb2gzZnRjejBqMzUzbmwifQ.In_t174elV-ZDaa7x4L-DQ',

    geocode: {
        method: 'GET',
        endpoint: `${baseEndpoint}/`,
        queryList: [
            'limit=1',
            'proximity=ip',
            'types=place%2Cpostcode%2Caddress'
        ]
    }
};